.errorBoundary {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.errorAlert {
  box-shadow: var(--lseg-box-shadow-moderate);
}
